import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import React from "react";
import moment from "moment";
import StatusBadge from "cxfcomponents/StatusBadge";
import UsersCell from "layouts/Flows/components/UsersCell";
import useThemeDetector from "hooks/useThemeDetector";

const Tiles = ({ rows }) => {
  const { isDarkMode } = useThemeDetector();

  return (
    <SoftBox
      display="grid"
      sx={{
        gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
        gap: 1,
        justifyContent: "start",
        alignItems: "stretch",
        marginBottom: "16px"
      }}
    >
      {rows.map((row) => (
        <Card
          key={row.id}
            sx={{
            width: "100%",
            minWidth: "373px",
            height: "100%",
            boxShadow: isDarkMode ? "0px 20px 27px rgba(0, 0, 0, 0.05)" : "none",
            margin: "0 auto",
            padding: 3,
          }}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <SoftBox
              sx={{
                flexShrink: 0,
                height: {
                  sm: "64px",
                  lg: "94px",
                },
                width: {
                  sm: "64px",
                  lg: "94px",
                },
              }}
            >
              {row.values?.icon}
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "start",
                width: "100%",
              }}
              ml={3}
              mt={1}
              lineHeight={0}
            >
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "start",
                  lineHeight: "0",
                  marginRight: "8px",
                }}
              >
                <SoftBox>
                  <SoftTypography
                    className="white-to-dark"
                    variant="h3"
                    fontWeight="bold"
                    fontSize="14px"
                  >
                    {row.values?.name}
                  </SoftTypography>
                  <SoftTypography
                    variant="h3"
                    fontWeight="bold"
                    fontSize="14px"
                    marginBottom="4px"
                    sx={{ color: "#718096" }}
                  >
                    {row.values?.type}
                  </SoftTypography>
                  <StatusBadge status={row.values?.status} />
                </SoftBox>
              </SoftBox>
              <SoftBox sx={{ marginLeft: "auto" }}>
                {React.cloneElement(row.values?.actions, { isVertical: true })}
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <SoftBox
            className="browse-tiles-divider"
            sx={{
              height: "1px",
              backgroundColor: "#E0E1E2",
              marginTop: "24px",
              marginBottom: "20px",
            }}
          />
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <UsersCell users={row.values?.users} />
            <SoftTypography
              fontSize="10px"
              display="flex"
              alignItems="flex-start"
            >
              <span style={{ fontWeight: 500, fontSize: "12px" }}>Last Updated:</span>
              <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: "8px" }}>
                <span>
                  {row.values?.last_updated && moment(row.values?.last_updated).format("MM/DD/YY")}
                </span>
                <span style={{ lineHeight: 1 }}>
                  {row.values?.last_updated && moment(row.values?.last_updated).format("h:mm:ss A")}
                </span>
              </span>
            </SoftTypography>
          </SoftBox>
        </Card>
      ))}
    </SoftBox>
  );
};

export default Tiles;
